export const SUMMARY_FIELDS = [
    {
        key: "AP_Code",
        label: "รหัสเจ้าหนี้",
        w: "8%",
        alignHeader: "center",
        align: "center",
        numeric: false,
        sortable: true,
    },
    {
        key: "DocType_Name",
        label: "ประเภท",
        w: "8%",
        alignHeader: "center",
        align: "center",
        numeric: false,
        sortable: true,
    },
    {
        key: "DocStatus_Name",
        label: "สถานะ",
        w: "8%",
        alignHeader: "center",
        align: "center",
        numeric: false,
        sortable: true,
    },
    {
        key: "AP_Import",
        label: "ประเภทลูกค้า",
        w: "6%",
        alignHeader: "center",
        align: "center",
        numeric: false,
        sortable: true,
    },
    {
        key: "AP_Name",
        label: "ชื่อเจ้าหนี้",
        w: "20%",
        alignHeader: "center",
        align: "left",
        numeric: false,
        sortable: true,
    },
    {
        key: "NetTotal",
        label: "สุทธิ",
        w: "7%",
        alignHeader: "end",
        align: "end",
        numeric: true,
        sortable: true,
    },
];

export const DETAIL_FIELDS = [
    {
        key: "Doc_Date",
        label: "วันที่",
        w: "12%",
        alignHeader: "center",
        align: "center",
        numeric: false,
    },
    {
        key: "Doc_No",
        label: "เลขที่เอกสาร",
        w: "12%",
        alignHeader: "center",
        align: "center",
        numeric: false,
    },
    {
        key: "Item_Code",
        label: "รหัสสินค้า",
        w: "17%",
        alignHeader: "center",
        align: "center",
        numeric: false,
    },
    {
        key: "Item_Name",
        label: "ชื่อสินค้า",
        w: "50%",
        alignHeader: "center",
        align: "center",
        numeric: false,
    },
    {
        key: "Item_Price_Unit",
        label: "ราคา/หน่วย",
        w: "12%",
        alignHeader: "center",
        align: "end",
        numeric: true,
    },
    {
        key: "Item_Qty",
        label: "จำนวน",
        w: "8%",
        alignHeader: "center",
        align: "end",
        numeric: true,
    },
    {
        key: "NetTotal",
        label: "รวมเงิน",
        w: "14%",
        alignHeader: "center",
        align: "end",
        numeric: true,
    },
    {
        key: "Item_Discount",
        label: "ส่วนลด",
        w: "8%",
        alignHeader: "center",
        align: "end",
        numeric: true,
    },
    {
        key: "Item_Total",
        label: "ราคารวม",
        w: "8%",
        alignHeader: "center",
        align: "end",
        numeric: true,
    },
];
